/* ============================================
   ONE SONGS — onesongs-fechas.js
   Calcula las fechas de entrega que se muestran en la pagina de producto.

   Reglas:
     · Envio gratis  = 5 dias habiles
     · Expres        = 1 dia habil si el pedido entra ANTES de las 7:30 p.m.
                       de un dia habil; si no, 2 dias habiles.
     · Dia habil     = lunes a viernes que NO sea festivo en Colombia.
     · La hora que manda es la de Bogota (UTC-5), no la del dispositivo
       del cliente.

   Escribe en #osf-date-normal y #osf-date-urgent.
   ============================================ */
(function () {
  'use strict';

  var CORTE_MIN = 19 * 60 + 30;   /* 7:30 p.m. */
  var DIAS_NORMAL = 5;

  /* ---------- Hora de Bogota ----------
     Colombia no usa horario de verano, asi que es UTC-5 fijo todo el ano. */
  function ahoraBogota() {
    var d = new Date();
    var utc = d.getTime() + d.getTimezoneOffset() * 60000;
    return new Date(utc - 5 * 3600000);
  }

  /* ---------- Festivos de Colombia ----------
     Muchos se corren al lunes siguiente por la Ley Emiliani. */
  function pascua(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100;
    var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var mes = Math.floor((h + l - 7 * m + 114) / 31);
    var dia = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, mes - 1, dia);
  }

  function alLunesSiguiente(d) {
    var r = new Date(d);
    while (r.getDay() !== 1) r.setDate(r.getDate() + 1);
    return r;
  }

  function clave(d) {
    return d.getFullYear() + '-' + d.getMonth() + '-' + d.getDate();
  }

  function festivosDe(y) {
    var set = {};
    function add(d) { set[clave(d)] = true; }

    /* Fecha fija */
    [[0, 1],    /* Ano Nuevo */
     [4, 1],    /* Dia del Trabajo */
     [6, 20],   /* Independencia */
     [7, 7],    /* Batalla de Boyaca */
     [11, 8],   /* Inmaculada Concepcion */
     [11, 25]   /* Navidad */
    ].forEach(function (f) { add(new Date(y, f[0], f[1])); });

    /* Se corren al lunes siguiente */
    [[0, 6],    /* Reyes Magos */
     [2, 19],   /* San Jose */
     [5, 29],   /* San Pedro y San Pablo */
     [7, 15],   /* Asuncion de la Virgen */
     [9, 12],   /* Dia de la Raza */
     [10, 1],   /* Todos los Santos */
     [10, 11]   /* Independencia de Cartagena */
    ].forEach(function (f) { add(alLunesSiguiente(new Date(y, f[0], f[1]))); });

    /* Ligados a la Pascua */
    var p = pascua(y);
    function desdePascua(n) { var r = new Date(p); r.setDate(r.getDate() + n); return r; }
    add(desdePascua(-3));                        /* Jueves Santo */
    add(desdePascua(-2));                        /* Viernes Santo */
    add(alLunesSiguiente(desdePascua(39)));      /* Ascension del Senor */
    add(alLunesSiguiente(desdePascua(60)));      /* Corpus Christi */
    add(alLunesSiguiente(desdePascua(68)));      /* Sagrado Corazon */

    return set;
  }

  /* Se calculan el ano actual y el siguiente, por si la fecha cruza diciembre */
  var _cache = null;
  function festivos(y) {
    if (!_cache || _cache.y !== y) {
      var s = festivosDe(y), s2 = festivosDe(y + 1);
      for (var k in s2) s[k] = true;
      _cache = { y: y, set: s };
    }
    return _cache.set;
  }

  /* ---------- Dias habiles ---------- */
  function esHabil(d, fest) {
    var w = d.getDay();
    if (w === 0 || w === 6) return false;
    return !fest[clave(d)];
  }

  function sumarHabiles(desde, n, fest) {
    var r = new Date(desde), sumados = 0;
    while (sumados < n) {
      r.setDate(r.getDate() + 1);
      if (esHabil(r, fest)) sumados++;
    }
    return r;
  }

  var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
               'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  function enEspanol(d) { return d.getDate() + ' de ' + MESES[d.getMonth()]; }

  /* ---------- Pintar ---------- */
  function pintar() {
    var elNormal = document.getElementById('osf-date-normal');
    var elExpres = document.getElementById('osf-date-urgent');
    if (!elNormal && !elExpres) return;

    var hoy = ahoraBogota();
    var fest = festivos(hoy.getFullYear());

    var antesDelCorte = (hoy.getHours() * 60 + hoy.getMinutes()) < CORTE_MIN;
    var diasExpres = (esHabil(hoy, fest) && antesDelCorte) ? 1 : 2;

    if (elNormal) elNormal.textContent = enEspanol(sumarHabiles(hoy, DIAS_NORMAL, fest));
    if (elExpres) elExpres.textContent = enEspanol(sumarHabiles(hoy, diasExpres, fest));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pintar);
  } else {
    pintar();
  }

  /* Expuesto para poder probarlo desde la consola */
  window.osFechas = { festivos: festivos, esHabil: esHabil, sumarHabiles: sumarHabiles, ahoraBogota: ahoraBogota };
})();
